import styled from 'styled-components';

const ProductCommentsSectionStyle = styled.div`
	--commentsWrapMarginTop: var(--sp7x);

	margin-top: var(--commentsWrapMarginTop);

	.comment-title {
		margin-bottom: var(--sp2x);
	}

	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--commentsWrapMarginTop: var(--sp6x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--commentsWrapMarginTop: var(--sp6x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--commentsWrapMarginTop: var(--sp5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--commentsWrapMarginTop: var(--sp5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--commentsWrapMarginTop: var(--sp5x);
	}
`;

export default ProductCommentsSectionStyle;
